<template>
	<button
		data-testid="button-component"
		:type="type"
		:class="[
			'ui button',
			semanticClass,
			color,
			{ outlined: outlined },
			{ width__auto: widthAuto },
			{ bubble__button: bubbleButton },
			{ iconed: icon || lefticon },
		]"
		:disabled="isDisabled"
		@click="$emit('click')"
	>
		<i
			v-if="lefticon && !loading"
			:class="['iconButton', lefticon]"
		/>
		{{ loading ? '' : label }}
		<i
			v-if="icon && !loading"
			:class="['iconButton', icon]"
		/>
		<Spinner
			v-if="loading"
			class="h-4 !opacity-100"
		/>
	</button>
</template>

<script>
// import Loading from "../Loading/Loading.vue";
import Spinner from '../Spinner/Spinner.vue'

export default {
	components: {
		// Loading,
		Spinner,
	},
	props: {
		lefticon: {
			type: String,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		bubbleButton: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'trv-default',
			validator: (value) => {
				return (
					['trv-default', 'trv-primary', 'trv-secondary', 'trv-error', 'trv-neutral'].indexOf(
						value,
					) !== -1
				)
			},
		},
		disabled: {
			type: [Boolean, Number],
			default: false,
		},
		icon: String,
		label: String,
		toggleable: {
			type: Boolean,
			default: true,
		},
		outlined: {
			type: Boolean,
			default: false,
		},

		semanticClass: String,
		type: {
			type: String,
			default: 'button',
			validator: (value) => {
				return ['button', 'submit', 'reset'].indexOf(value) !== -1
			},
		},
		widthAuto: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isDisabled() {
			return this.disabled
		},
	},
}
</script>

<style scoped>
.ui.button {
	width: 100%;
	color: white;
	font-weight: 100;
	display: flex;
	justify-content: center;
	border: 1px solid;
	align-items: center;
	padding: 0.5rem 1rem;
	font-size: 1rem;
}

/* .ui.button:focus {
  background-color: transparent
} */

.ui.button.iconed {
	gap: 0.5rem;
}

/* .ui.button:disabled {
  cursor: not-allowed;
  background-color: var(--color-gray);
} */

.ui.button.width__auto {
	width: auto;
}

.iconButton {
	margin-right: 0rem;
}

.ui.button.bubble__button {
	border-radius: 50%;
	height: 2rem;
	width: 2rem;
}
.ui.button.bubble__button .iconButton {
	margin-right: 0;
}

.trv-default,
.trv-default:hover
/* .trv-default:focus  */ {
	background-color: rgb(var(--color-default));
}

.trv-default:disabled {
	background-color: rgb(var(--color-default), 0.4);
}
.trv-primary,
.trv-primary:hover
/* ,
.trv-primary:focus  */
.trv-primary:active {
	background-color: rgb(var(--color-primary));
}

.trv-primary:disabled {
	background-color: rgb(var(--color-primary), 0.4);
}
.trv-secondary,
.trv-secondary:hover
/* 
,
.trv-secondary:focus  */ {
	background-color: rgb(var(--color-secondary));
	color: white;
}

.trv-secondary:disabled {
	background-color: rgb(var(--color-secondary), 0.4);
}
.trv-error,
.trv-error:hover
/* .trv-error:focus */ {
	background-color: rgb(var(--color-error));
}

.trv-error:disabled
/* .trv-error:focus */ {
	background-color: rgb(var(--color-error), 0.4);
}

.outlined.trv-error:disabled {
	background-color: transparent;
}

.trv-neutral,
.trv-neutral:hover
/* .trv-neutral:focus  */ {
	background-color: rgb(var(--color-neutral));
}

.trv-neutral:disabled {
	background-color: rgb(var(--color-neutral), 0.4);
}

.outlined {
	background-color: transparent;
	transition: background-color 0.2s ease-in-out;
}

.outlined.trv-default {
	border: 1px solid rgb(var(--color-default));
	color: rgb(var(--color-default));
	background-color: transparent;
}
.outlined.trv-default:hover
/* ,.outlined.trv-default:focus */ {
	background-color: rgba(var(--color-default));
	color: white;
}

.outlined.trv-primary {
	border: 1px solid rgb(var(--color-primary));
	color: rgb(var(--color-primary));
	background-color: transparent;
}
.outlined.trv-primary:hover,
.outlined.trv-primary:active,
.outlined.trv-primary:focus {
	background-color: rgba(var(--color-primary));
	color: white;
}

.outlined.trv-secondary {
	border: 1px solid rgb(var(--color-secondary));
	color: rgb(var(--color-secondary));
}
.outlined.trv-secondary:hover
/* ,.outlined.trv-secondary:focus  */ {
	background-color: rgba(var(--color-secondary));
	color: white;
}

.outlined.trv-error {
	border: 1px solid rgb(var(--color-error));
	color: rgb(var(--color-error));
}
.outlined.trv-error:hover
/* .outlined.trv-error:focus  */ {
	background-color: rgba(var(--color-error));
	color: white;
}

.outlined.trv-neutral {
	border: 1px solid rgb(var(--color-neutral));
	color: rgb(var(--color-neutral));
	background-color: transparent;
}
.outlined.trv-neutral:hover
/* ,.outlined.trv-neutral:focus  */ {
	background-color: rgba(var(--color-neutral));
	color: white;
}

@media screen and (max-width: 1880) {
	.ui.button {
		font-size: 1rem;
	}
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.ui.button {
		font-size: 0.75rem;
	}

	.tag_cabecalho_modelo.container__tag.default.outlined {
		font-size: 0.75rem;
	}
}
</style>
